import React from 'react';
import JSXCode from '../../Components/JSXCode';
import NewDesign from 'components/NewDesign';

const TabDialogSnippet = (props) => {
  //! State

  //! Function

  //! Render

  return (
    <div className='component:TabDialogSnippet'>
      <NewDesign.Typography className='tw-text-2xl tw-mb-5' component='p'>
        For quickly creating a new Dialog
      </NewDesign.Typography>

      <div className='tw-flex tw-flex-col tw-gap-4'>
        <div className='each-step'>
          <NewDesign.Typography className='tw-text-lg'>
            Step 1: Create new state for handling on/off dialog - Snippet: genNewDialog
          </NewDesign.Typography>
          <div className='tw-mt-3'>
            <JSXCode
              code={`const [openDialog, toggleDialog, shouldRenderDialog] = useToggleDialog();`}
            />
          </div>
        </div>

        <div className='each-step'>
          <NewDesign.Typography className='tw-text-lg'>
            Step 2: Create Your Dialog Component - Snippet: genNewDialog
          </NewDesign.Typography>

          <div className='tw-mt-3'>
            <JSXCode
              code={`import React, { Fragment } from 'react';
  import * as Yup from 'yup';
  import { useTranslation } from 'react-i18next';
  import NewDesign from 'components/NewDesign';
  import FormikFields from 'components/FormikFields';
  
  /**
   *
   * @param {Object} props
   * @param {boolean} props.isOpen
   * @param {() => void} props.toggle
   * @param {(values, formikHelpers) => void} props.onSubmit
   * @returns
   */
  const YourDialog = ({ isOpen, toggle, onSubmit }) => {
    const { t } = useTranslation();
  
    return (
      <NewDesign.Dialog
          isOpen={isOpen}
          toggle={toggle}
          className='component:YourDialog'
          form={{
            initialValues: {
              username: '',
              password: '',
            },
            onSubmit: onSubmit,
            validationSchema: Yup.object().shape({
              username: Yup.string().required('Username is required field!'),
              password: Yup.string().required('Password is required field!'),
            }),
          }}
          header='Dialog Form'
          content={(formikHelpers) => {
            const { values } = formikHelpers;
            return (
              <div>
                <code>{JSON.stringify(values)}</code>
                <div className='tw-flex tw-my-2 tw-flex-col tw-gap-2'>
                  <FormikFields.Input
                        name='username'
                        label='Username'
                        placeholder='Type username'
                        required
                  />
                  <FormikFields.Input
                        name='password'
                        label='Password'
                        placeholder='Type password'
                        type='password'
                        required
                  />
                </div>
              </div>
            );
          }}
          footer={(formikHelpers) => {
            const { toggle, isSubmitting } = formikHelpers;
    
            return (
              <Fragment>
                    <NewDesign.Button isLoading={isSubmitting} type='submit'>{t('shared:submit')}</NewDesign.Button>
                    <NewDesign.Button type='button' variant='ghost' onClick={toggle}>{t('shared:close')}</NewDesign.Button>
              </Fragment>
            );
          }}
      />
    );
  };
  
  export default YourDialog;
`}
            />
          </div>
        </div>

        <div className='each-step'>
          <NewDesign.Typography className='tw-text-lg'>Step 3: Final</NewDesign.Typography>
          <div className='tw-mt-3'>
            <JSXCode
              code={`import React from 'react';
import useToggleDialog from 'hooks/useToggleDialog';
import YourDialog from './YourDialog';

const Component = (props) => {
    const [openDialog, toggleDialog, shouldRenderDialog] = useToggleDialog();

    return (
      <Fragment>
              {shouldRenderDialog && <YourDialog isOpen={openDialog} toggle={toggleDialog} />}
              <NewDesign.Button onClick={toggleDialog}>Open dialog</NewDesign.Button>
      </Fragment>
    )
}

export default Component;`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabDialogSnippet;
